export enum GameModes {
    None,
    FourForEach,
    FirstToPress
}